import axios from 'axios'
import { Cookies } from 'react-cookie';

const cookies = new Cookies();
const token = cookies.get('JWTcookie')
const baseURL = process.env.REACT_APP_BASE_URL+'/api'
var instance = axios.create({
  baseURL: baseURL,
  timeout:100000,
  headers: { 'Authorization': 'Bearer ' + token }
});

export const csvGetReq = async (path) => {
  try {
    const response = await instance.get(
      `/${path}`
    )
    const data = response.data
    return data
  } catch (error) {
    console.warn(error)
  }
}

export const importCSV = async (path, form) => {
  try {
    instance.headers = {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    }
    const response = await instance.post(
      `/${path}/ImportCSV`, form, 
    )
    const data = response.data
    return data
  } catch (error) {
    console.warn(error)
  }
}



